<template>
  <div>
    <div class="main">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-button type="primary" @click="clickBack">返回</el-button>
              <el-select v-model="queryData.courseType" placeholder="课程分类">
                <el-option label="课程分类" value="0"></el-option>
                <el-option
                  v-for="item in aptustwoGvListCourseType" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
              <el-select v-model="queryData.priorityType" placeholder="优先分类">
                <el-option label="新课优先" value="1"></el-option>
                <el-option label="人气优先" value="2"></el-option>
              </el-select>
              <el-select v-model="queryData.courseDifficulty" placeholder="课程难度">
                <el-option label="课程难度" value="0"></el-option>
                <el-option
                  v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
              <el-select v-model="queryData.courseTimeType" placeholder="课程时长分类">
                <el-option label="时长分类" value="0"></el-option>
                <el-option
                  v-for="item in aptustwoGvListCourseTimeType" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
              <el-select v-model="queryData.bodyType" placeholder="部位分类">
                <el-option label="部位分类" value=""></el-option>
                <el-option
                  v-for="item in aptustwoGvListBodyType" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
              <el-select v-model="queryData.courseAccessories" placeholder="所需配件">
                <el-option label="所需配件" value=""></el-option>
                <el-option
                  v-for="item in aptustwoGvListAccessories" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
              <el-input v-model="queryData.courseName"  placeholder="课程名称"></el-input>
              <el-select v-model="queryData.isHome" placeholder="首页推荐">
                <el-option label="首页推荐" value="-1"></el-option>
                <el-option label="不推荐" value="0"></el-option>
                <el-option label="推荐" value="1"></el-option>
              </el-select>
              <el-select v-model="queryData.isBanner" placeholder="Banner推荐">
                <el-option label="Banner推荐" value="-1"></el-option>
                <el-option label="不推荐" value="0"></el-option>
                <el-option label="推荐" value="1"></el-option>
              </el-select>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
            <el-table-column prop="courseTypeUi" label="课程分类" sortable="custom"></el-table-column>
            <el-table-column prop="bodyTypeUi" label="部位分类" sortable="custom"></el-table-column>
            <el-table-column prop="courseName" label="课程名称" sortable="custom"></el-table-column>
            <el-table-column prop="" label="课程列表封面" width="120">
              <template v-slot="scope">
                <img :src="scope.row.courseIconUi" min-width="48" height="48" />
              </template>
            </el-table-column>
            <el-table-column prop="courseDifficultyUi" label="课程难度" sortable="custom"></el-table-column>
            <el-table-column prop="actionTime" label="课程时长" sortable="custom">
              <template slot-scope="props">
                {{props.row.courseTime}}分钟
              </template>
            </el-table-column>
            <el-table-column prop="" label="预计容量" width="120">
              <template v-slot="scope">
                {{scope.row.courseKg}}Kg
              </template>
            </el-table-column>
            <el-table-column prop="courseKcal" label="预计消耗" sortable="custom"></el-table-column>
            <el-table-column prop="isHome" label="首页推荐" sortable="custom">
              <template slot-scope="props">
                <span v-if="props.row.isHome == 0">否</span>
                <span v-if="props.row.isHome == 1">是</span>
              </template>
            </el-table-column>
            <el-table-column prop="isBanner" label="Banner推荐" sortable="custom">
              <template slot-scope="props">
                <span v-if="props.row.isBanner == 0">否</span>
                <span v-if="props.row.isBanner == 1">是</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            <el-table-column prop="Operation" label="操作" width="200">
              <template slot-scope="scope">
                <el-link :underline="false" type="danger" class="mr12" @click="ClickBind(scope.row)">绑定</el-link>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="5"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->

      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      aptustwoGvListCourseType:[],
      aptustwoGvListCourseDifficulty:[],
      aptustwoGvListCourseTimeType:[],
      aptustwoGvListBodyType:[],
      aptustwoGvListAccessories:[],
      queryData: {
        courseType: '0',
        priorityType: '1',
        courseDifficulty: '0',
        courseTimeType: '0',
        bodyType: '',
        courseAccessories: '',
        courseName: '',
        isHome: '-1',
        isBanner: '-1'
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
      // 绑定
      bindForm: {
        courseId: '',
        id: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.bindForm.id = row.id
      this.aptustwoGvListCourseType = JSON.parse(localStorage.getItem('aptustwoGvListCourseType'));
      this.aptustwoGvListCourseDifficulty = JSON.parse(localStorage.getItem('aptustwoGvListCourseDifficulty'));
      this.aptustwoGvListCourseTimeType = JSON.parse(localStorage.getItem('aptustwoGvListCourseTimeType'));
      this.aptustwoGvListBodyType = JSON.parse(localStorage.getItem('aptustwoGvListBodyType'));
      this.aptustwoGvListAccessories = JSON.parse(localStorage.getItem('aptustwoGvListAccessories'));
      this.CourseDatabaseList()
      this.CourseDatabaseNum()
    },
    handleSortChange ({ prop, order }) {
      const fieldMap = {
        'courseTypeUi': 'courseType',
        'bodyTypeUi': 'bodyType'
      }
      this.sortField = fieldMap[prop] || prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.CourseDatabaseList()
      this.CourseDatabaseNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.CourseDatabaseList()
      this.CourseDatabaseNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.CourseDatabaseList()
      this.CourseDatabaseNum()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clickQuery () {
      this.page_no = 1
      this.CourseDatabaseList()
      this.CourseDatabaseNum()
    },
    clickQueryReset () {
      this.queryData.courseType = '0'
      this.queryData.priorityType = '1'
      this.queryData.courseDifficulty = '0'
      this.queryData.courseTimeType = '0'
      this.queryData.bodyType = ''
      this.queryData.courseAccessories = ''
      this.queryData.courseName = ''
      this.queryData.isHome = '-1'
      this.queryData.isBanner = '-1'
      this.clickQuery()
    },
    ClickBind (row) {
      this.bindForm.courseId = row.id
      this.TrainPlanDatabaseSubUpdate()
    },
    CourseDatabaseList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.courseType = that.queryData.courseType
      data.priorityType = that.queryData.priorityType
      data.courseDifficulty = that.queryData.courseDifficulty
      data.courseTimeType = that.queryData.courseTimeType
      data.bodyType = that.queryData.bodyType
      data.courseAccessories = that.queryData.courseAccessories
      data.courseName = that.queryData.courseName
      data.isHome = that.queryData.isHome
      data.isBanner = that.queryData.isBanner
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseDatabaseList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    CourseDatabaseNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.courseType = that.queryData.courseType
      data.priorityType = that.queryData.priorityType
      data.courseDifficulty = that.queryData.courseDifficulty
      data.courseTimeType = that.queryData.courseTimeType
      data.bodyType = that.queryData.bodyType
      data.courseAccessories = that.queryData.courseAccessories
      data.courseName = that.queryData.courseName
      data.isHome = that.queryData.isHome
      data.isBanner = that.queryData.isBanner
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseDatabaseNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanDatabaseSubUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.bindForm.id
      data.courseId = that.bindForm.courseId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseSubUpdate, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.$emit('triggerFunc', '')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 110px;
    margin-right: 15px;
  }

  .el-select{
    width: 110px;
    margin-right: 15px;
  }

  .el-button{
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
